// Create a navbar component with links to different sections of the app

import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../css/navbar.module.css';
import { FaSearch } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { FaPersonCirclePlus } from 'react-icons/fa6';
import { IoIosLogOut } from 'react-icons/io';
import { TbReport } from 'react-icons/tb';
import { AppContext } from '../store/context/context';
import { useContext } from 'react';
import { FaHome } from 'react-icons/fa';
import { FaHistory } from 'react-icons/fa';
import { XCircleIcon } from 'lucide-react';

export default function Navbar() {
  const navigate = useNavigate();
  const logOutContext = useContext(AppContext);

  return (
    <nav className={styles.navbar}>
      <Link to="/" className={styles.siteTitle}>
        <img src={require('../assets/SpotFinderLogo.png')} alt="SpotFinder Logo" className={styles.logo} />
      </Link>

      <ul>
        <li>
          <FaSearch
            className={styles.navLink}
            size={36}
            color="#fff"
            onClick={(e) => {
              // searchItem &&
              navigate('/SearchPage');
            }}
          />
        </li>
        <li>
          <Link to="/" className={styles.navLink}>
            <FaHome
              style={{
                marginRight: '8px',
              }}
            />
            Home
          </Link>
        </li>
        <li>
          <Link to="/CloseTicketScreen" className={styles.navLink}>
            <XCircleIcon
              style={{
                marginRight: '8px',
              }}
            />
            Manual Close
          </Link>
        </li>

        <li>
          <Link to="/updatedReports" className={styles.navLink}>
            <TbReport
              style={{
                marginRight: '5px',
              }}
            />
            Reports
          </Link>
        </li>
        <li>
          <Link to="/ManualTicketsRemoval" className={styles.navLink}>
            <FaPersonCirclePlus
              style={{
                marginRight: '5px',
              }}
            />
            Manual Checkouts
          </Link>
        </li>
        <li>
          <Link to="/updatedDash" className={styles.navLink}>
            <FaHistory
              style={{
                marginRight: '5px',
              }}
            />
            Dashboard
          </Link>
        </li>

        <li>
          <Link
            to="/userLogin"
            className={styles.navLink}
            onClick={() => {
              logOutContext.setIsAuth(false);
              // logOutContext.logout();
              navigate('/userLogin');
              // window.location.href = '/userLogin';
            }}
          >
            <IoIosLogOut
              style={{
                marginRight: '5px',
              }}
            />
            Logout
          </Link>
        </li>
        <li>
          <div>
            <Link
              // popoverTarget="popover-target"
              to={''}
              className={styles.navLink}
              style={{ backgroundColor: 'red', borderRadius: '15px' }}
            >
              User: {logOutContext.user}
            </Link>
          </div>
        </li>
      </ul>
    </nav>
  );
}
